import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Injector, OnDestroy, afterNextRender, computed, effect, inject, input, signal } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';

import { CommonModule, NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'iea-home-page-gallery-box',
    templateUrl: './home-page-gallery-box.component.html',
    styleUrls: ['./home-page-gallery-box.component.scss'],
    host: { class: 'box' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, NgOptimizedImage, CommonModule],
    standalone: true,
})
export class HomePageGalleryBoxComponent implements OnDestroy {
    artBoards = input.required<any[], any[]>({
        transform: (v) =>
            v.map((x) => ({
                ...x,
                thumb: {
                    alt: x.title ?? x.slug,
                    src: `${x.largeImage?.path}?view=1&attachment=inline&w=512&h=512`,
                    width: 512,
                    height: 512,
                },
            })),
    });
    category = input.required<any>();
    activeItem = computed(() => {
        const idx = this.activeArtBoardIndex();
        const artBoards = this.artBoards();

        if (idx < 0 || idx >= artBoards.length) return null;

        return {};
    });

    thumb = computed(() => `/category/${this.category()._id.trim()}.jpg`);

    activeArtBoardIndex = signal(0);
    private observer!: any;

    private readonly host = inject(ElementRef);
    private readonly injector = inject(Injector);
    constructor() {
        afterNextRender(() => {
            effect(
                () => {
                    const observer = new IntersectionObserver((entries) => {
                        if (entries[0].isIntersecting) {
                            this.subscribe(this.artBoards());
                        } else {
                            this.unSubscribe();
                        }
                    });
                    observer.observe(this.host.nativeElement);
                },
                { injector: this.injector }
            );
        });
    }

    ngOnDestroy() {
        this.unSubscribe();
    }

    sub!: Subscription;
    async subscribe(artBoards: any[]) {
        this.unSubscribe();
        const d = 4000 + 250 * Math.ceil(Math.random() * artBoards.length);

        this.sub = interval(d).subscribe((x) => {
            this.activeArtBoardIndex.set((this.activeArtBoardIndex() + 1) % artBoards.length);
        });
    }

    unSubscribe() {
        if (this.observer) this.observer.disconnect();
        this.sub?.unsubscribe();
    }
}
